import {PaymentMethodSelection} from "@bounce/shared/consumer/declarations";
import {PAYMENT_METHOD_OPTION_BY_SELECTABLE_METHOD, PaymentMethodOption} from "@bounce/shared/consumer/pages/payment";

const FALLBACK_PAYMENT_METHOD: PaymentMethodOption = "DebitCard";

export const DEFAULT_PAYMENT_METHOD_SELECTION: PaymentMethodSelection = {
  methods: ["ach", "card", "apple_pay"],
  default: "ach",
};

type Params = {
  selection: PaymentMethodSelection;
  canDisplay: (method: PaymentMethodOption) => boolean;
  canBeDefault: (method: PaymentMethodOption) => boolean;
};

export const resolvePaymentMethods = ({selection, canDisplay, canBeDefault}: Params) => {
  const displayed = selection.methods
    .map((method) => PAYMENT_METHOD_OPTION_BY_SELECTABLE_METHOD[method])
    .filter(canDisplay);
  const candidates = [PAYMENT_METHOD_OPTION_BY_SELECTABLE_METHOD[selection.default], ...displayed];
  const defaultMethod =
    candidates.find((method) => displayed.includes(method) && canBeDefault(method)) ?? FALLBACK_PAYMENT_METHOD;
  const methods = displayed.includes(defaultMethod) ? displayed : [...displayed, defaultMethod];

  return {methods, defaultMethod};
};
